if(typeof RevealingText != 'function'){
    class RevealingText extends HTMLElement {
        constructor() {
            super(),
            this._paragraph = null,
            this.split = null,
            this.masks = [],
            this.splitTimeline = null,
            this.chars = null
            // console.log("reveal-text:constructor");
            
        }
        connectedCallback() {
            // console.log("reveal-text:connectedCallback");
            this._paragraph = this.querySelector("[data-text-reveal]"),
            this.splitRevealText(this._paragraph),
            this.resizeObserver = new ResizeObserver( () => {
                this.splitRevealText(this._paragraph)
            }
            ),
            this.resizeObserver.observe(this._paragraph)
        }
        splitRevealText(targetParagraph) {
            // console.log("reveal-text: splitRevealText",{targetParagraph});
            // console.log("reveal-text",{split:this.split});
            
            this.split && this.split.revert(),
            this.splitTimeline && this.splitTimeline.kill(),
            this.dataset.revealStyle == "style-1" ? (this.split = new SplitText(targetParagraph,{
                type: "lines",
                linesClass: "revealing-text-line"
            }),
            this.split.lines.forEach(target => {
                gsap.to(target, {
                    backgroundPositionX: 0,
                    ease: "none",
                    scrollTrigger: {
                        trigger: target,
                        scrub: 1.5,
                        markers: !1,
                        start: "top 60%",
                        end: "bottom center"
                    }
                })
            }
            )) : (this.splitTimeline = gsap.timeline(),
            this.split = new SplitText(targetParagraph,{
                type: "words,chars",
                charsClass: "revealing-text-char"
            }),
            this.chars = this.split.chars,
            this.splitTimeline.from(this.chars, {
                duration: .8,
                opacity: 0,
                y: -10,
                ease: "circ.out",
                stagger: .02,
                scrollTrigger: {
                    trigger: targetParagraph,
                    markers: !1,
                    start: "top 60%",
                    end: "bottom center",
                    scrub: 1.5
                }
            }, "+=0"))
        }
        disconnectedCallback() {
            // console.log("reveal-text:disconnectedCallback");
            this.resizeObserver && this.resizeObserver.unobserve(this._paragraph),
            this.split && this.split.revert(),
            this.splitTimeline && this.splitTimeline.kill()
        }
        reinit() {
            // console.log("reveal-text:reinit");
            this.splitRevealText(this._paragraph)
        }
    }
    if (!customElements.get("reveal-text")) customElements.define("reveal-text", RevealingText)

}